'use client';

import { useEffect, useRef, useState } from 'react';

const DEFAULT_ROOT_MARGIN = '200px 0px';

export function useDeferredMediaRender<T extends HTMLElement>(rootMargin = DEFAULT_ROOT_MARGIN) {
  const ref = useRef<T | null>(null);
  const [shouldRenderMedia, setShouldRenderMedia] = useState(false);

  useEffect(() => {
    if (shouldRenderMedia) {
      return;
    }

    const target = ref.current;
    if (!target) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldRenderMedia(true);
          observer.disconnect();
        }
      },
      { rootMargin, threshold: 0.01 },
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, [rootMargin, shouldRenderMedia]);

  return { ref, shouldRenderMedia };
}
